import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Protected({ requiredRoles, children }) {
  const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (!currentUser) {
    // Handle the case when user data is not available
    return <Navigate to="/unauthorized" replace />;
  }

  //const userHasRequiredRole = requiredRoles.includes(currentUser.role_en);

  // if (!userHasRequiredRole) {
  //   // Handle the case when the user doesn't have a required role
  //   return <Navigate to="/unauthorized" replace />;
  // }

  return children;
}

export default Protected;
